import UnAuthenticated from './UnAuthenticated';

export default UnAuthenticated;
